import "vuetify/styles";
import { createApp } from "vue";
import App from "./App.vue";
import { createVuetify } from "vuetify";
import router from "./router";
import mitt from "mitt";
import "@/assets/global.css";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const url = new URL(window.location.href);

if (!url.hostname.includes("localhost") && url.pathname.includes("/wp-content/plugins/ibj-people/people-submissions/dist")) {
    throw new Error("Not found.");
}

const emitter = mitt();
const app = createApp(App);
const vuetify = createVuetify({
    components,
    directives,
});

app.use(vuetify);

app.config.globalProperties.emitter = emitter;

app.use(router).mount("#app");
